import img1 from "./WhatsApp Image 2025-11-25 at 3.48.56 PM.jpeg";
import img2 from "./WhatsApp Image 2025-11-25 at 3.48.58 PM (1).jpeg";
import img3 from "./WhatsApp Image 2025-11-25 at 3.48.58 PM.jpeg";
import img4 from "./WhatsApp Image 2025-11-25 at 3.48.59 PM (1).jpeg";
import img5 from "./WhatsApp Image 2025-11-25 at 3.48.59 PM (2).jpeg";
import img6 from "./WhatsApp Image 2025-11-25 at 3.48.59 PM.jpeg";
import img7 from "./WhatsApp Image 2025-11-25 at 3.49.12 PM (1).jpeg";
import img8 from "./WhatsApp Image 2025-11-25 at 3.49.12 PM (2).jpeg";
import img9 from "./WhatsApp Image 2025-11-25 at 3.49.12 PM.jpeg";
import img10 from "./WhatsApp Image 2025-11-25 at 3.49.13 PM (1).jpeg";
import img11 from "./WhatsApp Image 2025-11-25 at 3.49.13 PM (2).jpeg";
import img12 from "./WhatsApp Image 2025-11-25 at 3.49.13 PM.jpeg";
import img13 from "./WhatsApp Image 2025-11-25 at 3.49.14 PM (1).jpeg";
import img14 from "./WhatsApp Image 2025-11-25 at 3.49.14 PM (2).jpeg";
import img15 from "./WhatsApp Image 2025-11-25 at 3.49.14 PM.jpeg";
import img16 from "./WhatsApp Image 2025-11-25 at 3.49.15 PM (1).jpeg";
import img17 from "./WhatsApp Image 2025-11-25 at 3.49.15 PM (2).jpeg";
import img18 from "./WhatsApp Image 2025-11-25 at 3.49.15 PM.jpeg";
import img19 from "./WhatsApp Image 2025-11-25 at 3.49.16 PM (1).jpeg";
import img20 from "./WhatsApp Image 2025-11-25 at 3.49.16 PM (2).jpeg";
import img21 from "./WhatsApp Image 2025-11-25 at 3.49.16 PM (3).jpeg";
import img22 from "./WhatsApp Image 2025-11-25 at 3.49.16 PM.jpeg";
import img23 from "./WhatsApp Image 2025-11-25 at 3.49.17 PM (1).jpeg";
import img24 from "./WhatsApp Image 2025-11-25 at 3.49.17 PM (2).jpeg";
import img25 from "./WhatsApp Image 2025-11-25 at 3.49.17 PM.jpeg";
import img26 from "./WhatsApp Image 2025-11-25 at 3.49.18 PM (1).jpeg";
import img27 from "./WhatsApp Image 2025-11-25 at 3.49.18 PM (2).jpeg";
import img28 from "./WhatsApp Image 2025-11-25 at 3.49.18 PM (3).jpeg";
import img29 from "./WhatsApp Image 2025-11-25 at 3.49.18 PM.jpeg";
import img30 from "./WhatsApp Image 2025-11-25 at 3.49.19 PM (1).jpeg";
import img31 from "./WhatsApp Image 2025-11-25 at 3.49.19 PM (2).jpeg";
import img32 from "./WhatsApp Image 2025-11-25 at 3.49.19 PM.jpeg";
import img33 from "./WhatsApp Image 2025-11-25 at 3.49.20 PM (1).jpeg";
import img34 from "./WhatsApp Image 2025-11-25 at 3.49.20 PM (2).jpeg";
import img35 from "./WhatsApp Image 2025-11-25 at 3.49.20 PM (3).jpeg";
import img36 from "./WhatsApp Image 2025-11-25 at 3.49.20 PM.jpeg";
import img37 from "./WhatsApp Image 2025-11-25 at 3.49.21 PM (1).jpeg";
import img38 from "./WhatsApp Image 2025-11-25 at 3.49.21 PM (2).jpeg";
import img39 from "./WhatsApp Image 2025-11-25 at 3.49.21 PM.jpeg";
import img40 from "./WhatsApp Image 2025-11-25 at 3.49.22 PM (1).jpeg";
import img41 from "./WhatsApp Image 2025-11-25 at 3.49.22 PM (2).jpeg";
import img42 from "./WhatsApp Image 2025-11-25 at 3.49.22 PM.jpeg";
import img43 from "./WhatsApp Image 2025-11-25 at 3.49.23 PM (1).jpeg";
import img44 from "./WhatsApp Image 2025-11-25 at 3.49.23 PM (2).jpeg";
import img45 from "./WhatsApp Image 2025-11-25 at 3.49.23 PM.jpeg";
import img46 from "./WhatsApp Image 2025-11-25 at 3.49.24 PM (1).jpeg";
import img47 from "./WhatsApp Image 2025-11-25 at 3.49.24 PM (2).jpeg";
import img48 from "./WhatsApp Image 2025-11-25 at 3.49.24 PM (3).jpeg";
import img49 from "./WhatsApp Image 2025-11-25 at 3.49.24 PM.jpeg";
import img50 from "./WhatsApp Image 2025-11-25 at 3.49.25 PM (1).jpeg";
import img51 from "./WhatsApp Image 2025-11-25 at 3.49.25 PM (2).jpeg";
import img52 from "./WhatsApp Image 2025-11-25 at 3.49.25 PM.jpeg";
import img53 from "./WhatsApp Image 2025-11-25 at 3.49.26 PM.jpeg";

export default [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img22,
  img23,
  img24,
  img25,
  img26,
  img27,
  img28,
  img29,
  img30,
  img31,
  img32,
  img33,
  img34,
  img35,
  img36,
  img37,
  img38,
  img39,
  img40,
  img41,
  img42,
  img43,
  img44,
  img45,
  img46,
  img47,
  img48,
  img49,
  img50,
  img51,
  img52,
  img53,
];
